import firebase from "../../config/firebase";
export const getAds =
  (filter, lastVisible, onComplete = () => {}) =>
  async (dispatch) => {
    const category = [];
    if (filter.TL) category.push("TL");
    if (filter.FB) category.push("FB");
    if (filter.PCHG) category.push("PCHG");
    if (filter.ET) category.push("ET");
    if (filter.RT) category.push("RT");
    if (filter.TEC) category.push("TEC");
    if (filter.OT) category.push("OT");
    let ads = await firebase
      .firestore()
      .collection("vendor_bids")
      .where("status", "==", "active")
      .where("category", "in", category)
      .limit(20);

    // Check if there's a lastVisible document for pagination
    if (lastVisible) {
      ads = ads.startAfter(lastVisible);
    }
    ads.get().then(async (query) => {
      let ads_data = [];
      let newLastVisible = null;
      for await (let doc of query.docs) {
        ads_data.push({ ...doc.data(), id: doc.id });
      }
      if (!query.empty) {
        newLastVisible = query.docs[query.docs.length - 1];
      }
      if (lastVisible) {
        dispatch({
          type: "GET_ADS_LOAD_MORE",
          payload: {
            ads: ads_data,
            lastVisible: newLastVisible,
            hasMoreDocument: ads_data.length >= 20,
          },
        });
      } else {
        dispatch({
          type: "GET_ADS",
          payload: {
            ads: ads_data,
            lastVisible: newLastVisible,
            hasMoreDocument: ads_data.length >= 20,
          },
        });
      }
      onComplete();
    });
  };

export const addAdsViews = (id, userData) => async () => {
  const userViewRef = firebase
    .firestore()
    .collection("vendor_bids")
    .doc(id)
    .collection("views")
    .doc(userData.fan_id);

  const userViewDoc = await userViewRef.get();

  if (!userViewDoc.exists) {
    await firebase
      .firestore()
      .collection("vendor_bids")
      .doc(id)
      .update({
        total_views: firebase.firestore.FieldValue.increment(1),
      });

    await userViewRef.set({
      ...userData,
      viewed_at: firebase.firestore.FieldValue.serverTimestamp(),
    });
  }
};
